"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createInitialStateForNestedProperty = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _PropertyTypes = _interopRequireDefault(require("../constants/PropertyTypes"));

var assignInitialValueOrNullToProperty = function assignInitialValueOrNullToProperty(propertyKey) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (0, _defineProperty2.default)({}, propertyKey, initialValue);
};

var assignInitialValueForProperty = function assignInitialValueForProperty(property) {
  var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof property === "string") {
    return Object.assign({}, acc, assignInitialValueOrNullToProperty(property));
  } else if ((0, _typeof2.default)(property) === "object" && property.type) {
    if (property.type === _PropertyTypes.default.SIMPLE) {
      return Object.assign({}, acc, assignInitialValueOrNullToProperty(property.key, property.initialValue));
    } else if (property.type === _PropertyTypes.default.ORDERED_MAP) {
      return Object.assign({}, acc, (0, _defineProperty2.default)({}, property.key, null));
    } else if (property.type === _PropertyTypes.default.NESTED) {
      return Object.assign({}, acc, createInitialStateForNestedProperty(property));
    }
  }

  return acc;
};

var createInitialStateForNestedProperty = function createInitialStateForNestedProperty(property) {
  return Object.assign({}, (0, _defineProperty2.default)({}, property.key, property.children.reduce(function (acc, child) {
    return assignInitialValueForProperty(child, acc);
  }, {})));
};

exports.createInitialStateForNestedProperty = createInitialStateForNestedProperty;

var _default = function _default(properties) {
  return (0, _immutable.fromJS)(properties.reduce(function (acc, property) {
    return assignInitialValueForProperty(property, acc);
  }, {}));
};

exports.default = _default;